import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sqg-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-form__intro" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Bureautique :"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Il s’agit des modèles de document au format Word appelés à être utilisés de manière récurrente (par exemple, pour des contrats de travail pour générer automatiquement des informations qui varient selon les salariés)."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Nous avons besoin d’un exemple de document pour tout paramétrage. ")
], -1)
const _hoisted_3 = { class: "sqg-form__actionBar" }
const _hoisted_4 = { class: "sqg-form__actionBar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_CardButton = _resolveComponent("CardButton")!
  const _component_FormTemplate = _resolveComponent("FormTemplate")!
  const _component_Modale = _resolveComponent("Modale")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modale, {
      title: "Formulaire bureautique",
      width: "50",
      height: "90",
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
    }, {
      default: _withCtx(() => [
        (_ctx.loader)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              msg: _ctx.loaderMsg
            }, null, 8, ["msg"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.step === 0)
                ? (_openBlock(), _createBlock(_component_FormTemplate, { key: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_CardButton, {
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-right",
                          text: "Etape suivante",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.step++))
                        })
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.step === 1)
                ? (_openBlock(), _createBlock(_component_FormTemplate, {
                    key: 1,
                    formId: _ctx.formId,
                    inputs: _ctx.model.bureautique,
                    readOnly: _ctx.readOnly,
                    title: "Formulaire bureautique"
                  }, {
                    default: _withCtx(({ errorCount }) => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_CardButton, {
                          width: "100",
                          height: "96",
                          icon: "fas fa-arrow-left",
                          text: "Etape précédente",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.step--))
                        }),
                        (!_ctx.readOnly)
                          ? (_openBlock(), _createBlock(_component_CardButton, {
                              key: 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-save",
                              text: "Sauvegarder",
                              onClick: _ctx.saveForm
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (!_ctx.readOnly)
                          ? (_openBlock(), _createBlock(_component_CardButton, {
                              key: 1,
                              disabled: errorCount !== 0,
                              width: "100",
                              height: "96",
                              icon: "fas fa-paper-plane",
                              text: "Soumettre",
                              onClick: _ctx.submitForm
                            }, null, 8, ["disabled", "onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["formId", "inputs", "readOnly"]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    })
  ]))
}